import { render, staticRenderFns } from "./NewAddCandidate.vue?vue&type=template&id=af5f6d78&scoped=true"
import script from "./NewAddCandidate.vue?vue&type=script&lang=js"
export * from "./NewAddCandidate.vue?vue&type=script&lang=js"
import style0 from "./NewAddCandidate.vue?vue&type=style&index=0&id=af5f6d78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5f6d78",
  null
  
)

export default component.exports